import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusParking = (props) => {
    const width = props.width ? props.width + 'px' : '42px';
    const height = props.height ? props.height + 'px' : '39px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 42 39"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M42 34.8091H0V38.6891H42V34.8091Z" />
            <path d="M15.8071 20.4365H25.8282C30.5521 20.4171 34.3963 16.6144 34.4419 11.9321V11.8545V8.59499C34.4419 3.86742 30.5781 0.0194018 25.8217 0H11.585V32.0065H15.8006V20.4365H15.8071ZM15.8071 4.19078H25.8021C28.2455 4.19078 30.2263 6.1633 30.2263 8.58852V8.60146V11.8416V11.861C30.2263 14.2797 28.239 16.2522 25.8021 16.2522H15.8071V4.19078Z" />
        </SvgStyled>
    );
};

export default CampusParking;
